import * as echarts from 'echarts';
import { ECBasicOption } from "echarts/types/dist/shared";
import { useEffect, useRef } from "react";
import { openPage } from '../../../../../util/library/Router';
import { PATHNAME } from '../../../../../util/varibles/constants';

interface IProps {
    xAxis: any
    series: any
    rowMax: number
}

const ChartOps: React.FC<IProps> = (props) => {
    const opsRef = useRef<HTMLDivElement>(null);
    const { xAxis = {}, rowMax, series } = props;

    useEffect(() => {
        if (opsRef.current) {
            const existInstance = echarts.getInstanceByDom(opsRef.current)
            if (existInstance) echarts.dispose(opsRef.current)
            opsRef.current.style.height = rowMax > 0 ? `${rowMax * 24}px` : '2px';
            const opsChart = echarts.init(opsRef.current);
            opsChart?.on('click', (e: any) => {
                const { tenant_id, id } = e.data?.[2] || {};
                openPage(`${PATHNAME.OPERATION}/${tenant_id}/${id}`)
            });
            const option: ECBasicOption = {
                tooltip: {
                    trigger: 'item',
                },
                grid: {
                    top: 0,
                    right: '20px',
                    bottom: '5px'
                },
                xAxis: {
                    ...xAxis,
                    show: false,
                },
                yAxis: {
                    type: 'category',
                    axisLabel: { show: false },
                    axisTick: { show: false },
                    axisLine: { show: false, },
                    name: '',
                },
                series
            };
            opsChart.setOption(option, true);
        }
    }, [series, xAxis, rowMax]);

    return <div ref={opsRef} style={{ height: "2px", width: '100%' }} />
}

export default ChartOps;